import { render, staticRenderFns } from "./modal_takeaways.vue?vue&type=template&id=bac504d6&scoped=true&"
import script from "./modal_takeaways.vue?vue&type=script&lang=js&"
export * from "./modal_takeaways.vue?vue&type=script&lang=js&"
import style0 from "./modal_takeaways.vue?vue&type=style&index=0&id=bac504d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac504d6",
  null
  
)

export default component.exports